export default {
    startsWith: 'Commence par',
    contains: 'Contient',
    notContains: 'Ne contient pas',
    endsWith: 'Termine par',
    equals: 'Égal à',
    notEquals: 'Pas égal à',
    noFilter: 'Aucun filtre',
    lt: 'Inférieur à',
    lte: 'Inférieur ou égal à',
    gt: 'Supérieur à',
    gte: 'Supérieur ou égal à',
    dateIs: 'Date vaut',
    dateIsNot: 'Date ne vaut pas',
    dateBefore: 'Date avant',
    dateAfter: 'Date après',
    clear: 'Effacer',
    apply: 'Appliquer',
    matchAll: 'Tous',
    matchAny: 'N\'importe',
    addRule: 'Ajouter règle',
    removeRule: 'Retirer',
    accept: 'Oui',
    reject: 'Non',
    choose: 'Choisir',
    upload: 'Transférer',
    cancel: 'Annuler',
    dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["Di","Lu","Ma","Me","Je","Ve","Sa"],
    monthNames: ["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun","Jul", "Auo", "Sep", "Oct", "Nov", "Dec"],
    today: 'Aujourd\'hui',
    weekHeader: 'Sm',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Faible',
    medium: 'Moyen',
    strong: 'Fort',
    passwordPrompt: 'Choisissez un mot de passe',
    emptyFilterMessage: 'Aucun résultat trouvé',
    emptyMessage: 'Pas d\'option disponible'
}
